import { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { createIdCard } from '@/apis/idCards'
import useNotification from '@/hooks/useNotification'
import routes from '@/routes'
import { CreateIdCardRequest, CreateIdCardResponse } from '@/types/apis/idCards'

export const useCreateIdCards = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const openNotification = useNotification()
  const [loading, setLoading] = useState(false)
  const [response, setResponse] = useState<CreateIdCardResponse>()

  const create = useCallback(
    async (request: CreateIdCardRequest) => {
      try {
        setLoading(true)
        const res = await createIdCard(request)
        setResponse(res)
        openNotification({ description: t('pages.idCards.create.createSuccessfully') })
        navigate(routes.idCards.path)
      } finally {
        setLoading(false)
      }
    },
    [navigate, openNotification, t]
  )

  return {
    loading,
    createIdCard: create,
    response,
  }
}
